import type { ChangeEvent } from 'react';

import { Close } from '@mui/icons-material';
import { ButtonBase, InputAdornment, TextField } from '@mui/material';

import { Icon } from '../../components/base';

interface SearchInputProps {
  value?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onReset?: () => void;
  placeholder?: string;
}

export const SearchInput = ({ value = '', onChange, onReset, placeholder }: SearchInputProps) => (
  <TextField
    value={value}
    placeholder={placeholder}
    onChange={onChange}
    InputProps={{
      sx: { height: '40px' },
      startAdornment: (
        <InputAdornment position='start'>
          <Icon icon='search' sx={{ width: '17px', height: '17px', marginRight: '10px' }} />
        </InputAdornment>
      ),
      endAdornment: (
        <InputAdornment position='end'>
          <ButtonBase onClick={onReset} sx={{ visibility: value && onReset ? 'visible' : 'hidden' }}>
            <Close sx={{ width: '17px', height: '17px', cursor: 'pointer' }} />
          </ButtonBase>
        </InputAdornment>
      ),
    }}
  />
);
